import api from "@/lib/api";

export const fetchActivePromos = (scope) =>
  api
    .get(`/promotions/active?scope=${scope}`)
    .then((r) => r.data)
    .catch(() => []);

export const validatePromoCode = (code, scope) =>
  api.post("/promotions/validate", { code, scope }).then((r) => r.data);

export const discountFor = (promo, total) => {
  if (!promo) return 0;
  if (promo.type === "fixed") {
    return Math.round(Math.min(total, Math.max(0, promo.value)) * 100) / 100;
  }
  const pct = Math.min(100, Math.max(0, promo.value));
  return Math.round(total * pct) / 100;
};

// Non cumulable : retourne la meilleure promotion (auto ou code) pour le montant donné.
export const bestPromo = (autoPromos, codePromo, total) => {
  const candidates = [...(autoPromos || []), codePromo].filter(Boolean);
  let best = null;
  let bestD = 0;
  for (const p of candidates) {
    const d = discountFor(p, total);
    if (d > bestD) {
      best = p;
      bestD = d;
    }
  }
  if (!best && candidates.length) {
    // Panier vide : afficher quand même la promo vitrine (prix barrés)
    const percents = candidates.filter((p) => p.type === "percent");
    best = percents.length
      ? percents.reduce((a, b) => (b.value > a.value ? b : a))
      : candidates[0];
  }
  return { promo: best, discount: bestD };
};

export const promoLabel = (promo) =>
  promo ? (promo.type === "fixed" ? `-${String(promo.value).replace(".", ",")} €` : `-${promo.value} %`) : "";
